export default __webpack_public_path__ + "static/media/sample.0d3ac948.png";